import styled from 'styled-components'

export const Container = styled.div`
  display: flex;
  flex-direction: row;
  width: 100vw;
  height: 100vh;
  padding: 1rem;
  gap: 2rem;
  align-items: center;
  justify-content: center;
  flex-wrap: wrap;
`
export const Section = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 2rem;

  > p {
    font-family: 'Raleway', sans-serif;
    font-size: 14px;
    font-weight: 400;
    margin-top: 0;
    margin-bottom: 15px;
    color: #333;
  }

  > h1 {
    font-family: 'Passion One', cursive;
    color: #00b5c3;
    font-size: 150px;
    letter-spacing: 15.5px;
    margin: 0px;
    font-weight: 900;
  }

  > h2 {
    font-family: 'Raleway', sans-serif;
    color: #292929;
    font-size: 28px;
    font-weight: 700;
    text-transform: uppercase;
    letter-spacing: 2.5px;
    margin-top: 0;
  }

  > div {
    display: flex;
    align-self: flex-start;
    align-items: center;
  }
`
